import axios from 'axios';
import {
  SET_SPINNER_LOADING
} from '../store/modules/common/constants';
import commonStore from '../store/modules/common';
import httpStatusCodes from './http-status-codes';
/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */
function parseJSON (response) {
  const hasData = response && (typeof response.data === 'string' || typeof response.data === 'object');
  if (response.headers && response.headers['x-api-version']) {
    localStorage.setItem('X_API_VERSION', response.headers['x-api-version']);
    if (hasData && typeof response.data === 'object') {
      response.data.apiVersion = response.headers['x-api-version'];
    }
  }
  return hasData ? response.data : response;
}

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
function checkStatus (response) {
  if (response && response.status >= httpStatusCodes.OK && response.status < httpStatusCodes.MULTIPLE_CHOICES) {
    return response;
  }
  // throw error;
  throw response;
}

/**
 * Add set timeout for api call,
 * if time is exceeded then throwing error timeout
 * regardless request is still calling in background
 *
 * @param  {promise function} fetchPromise Promise function
 * @param  {integer} ms                    Timeout in ms
 * @return {promise}                       The response
 */
function promiseNoAction (fetchPromise, options) {
  return new Promise((resolve, reject) => {
    fetchPromise
      .then(
        (res) => {
          let response = res || {};
          response.doubleClick = true;
          if (options && options.data) {
            response.doubleClick = options.data.doubleClick;
          }
          // standard response data from aduro platform
          if (response.data && response.data.data && response.data.data) {
            response.data = response.data.data;
          }
          resolve(response);
        },
        (err) => {
          reject(err);
        }
      );
  });
}

function fetchWithTimeout (fetchPromise, ms, dispatch) {
  return new Promise((resolve, reject) => {
    const timeoutId = setTimeout(() => reject(new Error('Time out')), ms);
    fetchPromise
      .then(
        (res) => {
          dispatch(SET_SPINNER_LOADING, false);
          clearTimeout(timeoutId);
          resolve(res);
        },
        (err) => {
          dispatch(SET_SPINNER_LOADING, false);
          clearTimeout(timeoutId);
          reject(err.response || err);
        }
      );
  });
}

/**
 * Requests a URL, returning a promise
 * @param {string} url - The URL we want to request
 * @param {Promise<import('axios').AxiosRequestConfig>} buildOptions - The options we want to pass to "fetch"
 * @param {import("vuex/types/index.d.ts").Commit} dispatch
 * @return {Promise<any>} - The response data
 */
export function makeCall(url, buildOptions, dispatch) {
  return buildOptions.then((options) => {
    if (commonStore.state.isLoading) {
      return promiseNoAction(axios(url, options), options);
    }
    dispatch(SET_SPINNER_LOADING, true);
    return fetchWithTimeout(axios(url, options), 20000, dispatch)
      .then(checkStatus)
      .then(parseJSON);
  });
}
